export default __webpack_public_path__ + "static/media/vardhinilogo.77c1d02b32d270f03999262d2745d626.webp";